import type { Topology } from 'topojson-specification';
import { getIslandsTopology } from './buildIslandsAtlas';
const cache = new Map<string, Topology>();
export async function loadAtlas(mapId: string): Promise<Topology> {
  if (cache.has(mapId)) {
    return cache.get(mapId)!;
  }
  let data: Topology;
  switch (mapId) {
    case 'nl-provinces':
      data = (await import('../../../content/atlases/nl/provinces.topo.json')).default as Topology;
      break;
    case 'nl-islands':
      data = getIslandsTopology();
      break;
    default:
      throw new Error(`Unknown atlas mapId: ${mapId}`);
  }
  cache.set(mapId, data);
  return data;
}